import { Box, Flex } from '@chakra-ui/react'
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons'

import ScrollContainer from 'src/components/widgets/ScrollContainer/ScrollContainer'

import ScrollButton from './ScrollButton/ScrollButton'
import useLarge from './useLarge'

const Large: React.FC<{
  children: React.ReactNode | React.ReactNode[]
  itemsPerRow: number
  width: number
  gap?: number
  offsetArrows?: number
}> = ({ children, itemsPerRow, width, gap = 6, offsetArrows = 0 }) => {
  const {
    showLeftArrow,
    showRightArrow,
    scroll,
    scrollContainer,
    containerWidth,
    items,
    itemWidth,
  } = useLarge({ children, itemsPerRow, width, gap })
  return (
    <Box w={width} position="relative" justifyItems="center">
      {showLeftArrow && (
        <ScrollButton
          icon={faChevronLeft}
          left={-16}
          top={offsetArrows - 16}
          onClick={() => scroll(-1)}
        />
      )}

      <ScrollContainer ref={scrollContainer}>
        <Flex w={containerWidth} gap={gap}>
          {items.map((item, i) => (
            <Box w={itemWidth} key={i}>
              {item}
            </Box>
          ))}
        </Flex>
      </ScrollContainer>

      {showRightArrow && (
        <ScrollButton
          icon={faChevronRight}
          right={-16}
          top={offsetArrows - 16}
          onClick={() => scroll(1)}
        />
      )}
    </Box>
  )
}

export default Large
